import Vue from 'vue';
import Vuex from 'vuex';

import mutations from './layout.mutations';
import actions from './layout.actions';

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    modal: {
      transfer: false,
      addReservationForm: false,
      editReservationForm: false,
      changePassword: false
    }
  },
  mutations,
  actions
};
